import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { fadeInMixin } from './cssMixins';

const dataGridStyle = ({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        margin: '0px'
    },
    [theme.breakpoints.up('xl')]: {
        margin: '0px 30px'
    },
    '& .MuiDataGrid-row:hover': {
        '& .actionsCell': {
            opacity: '1',
            transition: 'opacity 0.5s'
        }
    },
    '& .MuiDataGrid-row': {
        '& .actionsCell': {
            opacity: '0',
        }
    },
    ...fadeInMixin(),
});

export default styled(DataGrid)(dataGridStyle);